import React from "react";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { keycloak } from "../shared/libs/keycloak-auth";
import { Routes, Route, Navigate } from "react-router-dom";
import Factory from "./Factory";
import DashboardRoute from "./components/dashboard/DashboardRoute";
import OcorrenciaDetalhadaRoute from "./components/ocorrencia/OcorrenciaDetalhadaRoute";
import PrivateRoute from "../shared/components/PrivateRoute";

export default function App() {
  return (
    <Factory>
      <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={{ onLoad: "login-required", checkLoginIframe: false }}
      >
        <PrivateRoute>
          <Routes>
            <Route path="/" element={<DashboardRoute />} />
            <Route path="/ocorrencia/:id" element={<OcorrenciaDetalhadaRoute />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </PrivateRoute>
      </ReactKeycloakProvider>
    </Factory>
  );
}
